import { BackednResponse } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { GlobalDiscoveryService } from "../services/globalDiscovery.service";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";

export type FacetResult = {
	name: string;
	value: string;
	display_name?: string;
	type: string;
}[];

export const useGlobalDiscoveryFacets = ({
	facetName,
	body,
	query = "",
	work_platform_id = "",
	enabled = true,
}: {
	facetName: string;
	body: { [key: string]: any };
	query?: string;
	work_platform_id?: string;
	enabled?: boolean;
}) => {
	const { data, isFetching, isError, error } = useQuery<
		BackednResponse<FacetResult>
	>({
		queryKey: ["facets", facetName, body, query],
		queryFn: () =>
			GlobalDiscoveryService.getFacets({
				facetName,
				text: query,
				work_platform_id,
			}),
		enabled,
	});

	const errorMessage = isError && error?.message;

	useEffect(() => {
		if (errorMessage) {
			ToastService.error(errorMessage);
		}
	}, [errorMessage]);

	return {
		facet: data?.data,
		isFetching,
		isError,
	};
};
